module.exports = __webpack_public_path__ + "img/doctor-only.f5174a08.png";